<template>
  <div class="dialPhone">
    <el-dialog
      title="拨打电话"
      :visible.sync="showDialog"
      :fullscreen="true"
      :before-close="handClose"
    >
      <div class="dial_container" ref="container" @mousemove="onMousemove">
        <div class="dial_left">
          <div class="flex-al Inquire-box ml20 mt20">
            <div class="ipt-box">
              <el-input
                clearable
                style="width: 150px"
                placeholder="可检索标签类型名称"
                class="input-cont"
                v-model="keyword"
                @change="getDialRecord"
              ></el-input>
            </div>
            <el-button type="primary" class="btn-inquire" @click="getDialRecord"
              >查询</el-button
            >
          </div>
          <el-tabs v-model="dialActiveName" @tab-click="getDialRecord">
            <el-tab-pane
              :label="`待拨打（${waitDialLength}）`"
              name="first"
            ></el-tab-pane>
            <el-tab-pane
              :label="`已拨打（${alreadyDialLength}）`"
              name="second"
            ></el-tab-pane>
          </el-tabs>
          <div class="dial_list">
            <div
              class="one_dial"
              v-for="(item, index) in dialList"
              :key="index"
              @click="chooseDial(item, index)"
              :class="{ active_dial: index === dialIndex }"
            >
              <img v-if="item.client_img != ''" :src="item.client_img" />
              <img
                v-else-if="item.client_sex == '女'"
                src="@/assets/images/default-img-women.png"
                alt=""
              />
              <img v-else src="@/assets/images/default-img-man.png" alt="" />

              <div class="student_info">
                <div class="info_top">
                  <span
                    >{{ item.client_cnname }}{{ item.client_enname ? "/" : ""
                    }}{{ item.client_enname }}</span
                  >
                  <img
                    v-if="item.client_sex == '女'"
                    :src="require('@/assets/images/customer/icon-woman.png')"
                    alt=""
                  />
                  <img
                    v-else
                    :src="require('@/assets/images/customer/icon-man.png')"
                    alt=""
                  />
                </div>
                <div class="info_bottom">
                  <span>最近跟踪时间：</span>
                  <span>{{ item.track_createtime }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dial_right">
          <div class="dial_header">
            <div class="header_left">
              <div class="header_student">
                <img
                  v-if="UserInformation.client_img != ''"
                  :src="UserInformation.client_img"
                />
                <img
                  v-else-if="UserInformation.client_sex == '女'"
                  src="@/assets/images/default-img-women.png"
                  alt=""
                />
                <img v-else src="@/assets/images/default-img-man.png" alt="" />
                <div class="student_info">
                  <div class="info_top">
                    <span
                      >{{ UserInformation.client_cnname
                      }}{{ UserInformation.client_enname ? "/" : ""
                      }}{{ UserInformation.client_enname }}</span
                    >
                    <img
                      v-if="UserInformation.client_sex == '女'"
                      :src="require('@/assets/images/customer/icon-woman.png')"
                      alt=""
                    />
                    <img
                      v-else
                      :src="require('@/assets/images/customer/icon-man.png')"
                      alt=""
                    />
                  </div>
                  <div class="info_bottom">
                    <span class="info_label">主要联系人：</span>
                    <span class="info_content">{{
                      UserInformation.main_family_cnname
                    }}</span>
                    <span class="info_label">手机号：</span>
                    <span class="info_content">{{
                      UserInformation.client_mobile
                    }}</span>
                    <span class="info_label">出生日期：</span>
                    <span class="info_content">{{
                      UserInformation.client_birthday
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="header_label">
                <span
                  v-for="(item, index) in UserInformation.client_tags"
                  :key="index"
                  class="tagItem"
                >
                  {{ item.label_name }}
                </span>
                <span class="addTagBtn ml10" @click="addTagVisable = true"
                  >添加标签</span
                >
              </div>
            </div>
            <el-popover placement="bottom-start" trigger="click">
              <div
                v-for="(item, index) in UserInformation.client_family_list"
                class="popover_list"
                :class="{
                  mb10: !(
                    index ===
                    UserInformation.client_family_list.length - 1
                  ),
                }"
              >
                {{ item.family_cnname }}（{{ item.family_relation }}）：<span
                  style="cursor: pointer"
                  @click="callPhone(item)"
                  >{{ item.family_mobile }}</span
                >
              </div>

              <div class="header_right" slot="reference">
                <img
                  :src="require('@/assets/images/customer/phone3-icon.png')"
                  alt=""
                />
                <span>拨打电话</span>
              </div>
            </el-popover>
          </div>
          <div class="dial_main">
            <div class="main_left">
              <!-- 跟进 -->
              <el-tabs v-model="followActiveName">
                <el-tab-pane label="跟进" name="first">
                  <el-form
                    ref="followForm"
                    :rules="followRules"
                    :model="followForm"
                    label-width="140px"
                  >
                    <el-form-item :label="$t('User.follow_label1')">
                      <el-select
                        filterable
                        v-model="followForm.track_linktype"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder1')"
                      >
                        <el-option
                          v-for="items in CommodeData"
                          :key="items.commode_id"
                          :label="items.commode_name"
                          :value="items.commode_name"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('User.follow_label2')">
                      <el-select
                        filterable
                        v-model="followForm.object_code"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder2')"
                      >
                        <el-option
                          v-for="items in ObjectData"
                          :key="items.object_code"
                          :label="items.object_name"
                          :value="items.object_code"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('User.follow_label3')">
                      <el-radio-group v-model="followForm.track_validinc">
                        <el-radio label="1">{{
                          $t("User.follow_options1[0]")
                        }}</el-radio>
                        <el-radio label="2">{{
                          $t("User.follow_options1[1]")
                        }}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('User.follow_label4')">
                      <el-rate
                        v-model="followForm.track_intention_level"
                        :icon-classes="['crm-likes', 'crm-likes', 'crm-likes']"
                        void-icon-class="crm-like"
                        :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                      ></el-rate>
                    </el-form-item>
                    <el-form-item :label="$t('User.follow_label5')">
                      <el-radio-group
                        v-model="followForm.track_followmode"
                        @change="sourceFilter"
                        class="type-follow"
                      >
                        <el-radio label="1">{{
                          $t("User.follow_options2[0]")
                        }}</el-radio>
                        <el-radio label="2">{{
                          $t("User.follow_options2[1]")
                        }}</el-radio>
                        <el-radio label="0">{{
                          $t("User.follow_options2[2]")
                        }}</el-radio>
                        <el-radio
                          v-if="
                            UserInformation.client_tracestatus_status != '4'
                          "
                          label="-1"
                          >{{ $t("User.follow_options2[3]") }}</el-radio
                        >
                        <el-radio
                          v-if="
                            UserInformation.client_tracestatus_status != '4'
                          "
                          label="-2"
                          >{{ $t("User.follow_options2[4]") }}</el-radio
                        >
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followmode == '2'"
                      :label="$t('User.follow_label6')"
                    >
                      <el-select
                        filterable
                        v-model="followForm.audition_genre"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder6')"
                        @change="ClickAudition()"
                      >
                        <el-option
                          :label="$t('User.follow_options3[0]')"
                          value="0"
                        ></el-option>
                        <el-option
                          :label="$t('User.follow_options3[1]')"
                          value="1"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      v-if="
                        followForm.track_followmode == '1' ||
                        followForm.track_followmode == '2'
                      "
                      :label="$t('User.follow_label7')"
                      prop="receiver_name"
                    >
                      <el-select
                        filterable
                        v-model="followForm.receiver_name"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder7')"
                      >
                        <el-option
                          v-for="items in ReceiverList"
                          :key="items.marketer_id"
                          :label="items.marketer_name"
                          :value="items.marketer_name"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followmode == '1'"
                      :label="$t('User.follow_label8')"
                    >
                      <el-select
                        filterable
                        v-model="followForm.invite_genre"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder8')"
                      >
                        <el-option
                          :label="$t('User.follow_options4[0]')"
                          value="0"
                        ></el-option>
                        <el-option
                          :label="$t('User.follow_options4[1]')"
                          value="1"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followmode == '1'"
                      prop="invite_visittime"
                      :label="$t('User.follow_label9')"
                    >
                      <el-date-picker
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :placeholder="$t('User.follow_placeholder9')"
                        v-model="followForm.invite_visittime"
                        style="width: 340px"
                      ></el-date-picker>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followmode == '2'"
                      prop="audition_visittime"
                      :label="$t('User.follow_label10')"
                    >
                      <el-date-picker
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :placeholder="$t('User.follow_placeholder10')"
                        v-model="followForm.audition_visittime"
                        @change="ClickAuditiontime()"
                        style="width: 340px"
                      ></el-date-picker>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followmode == '2'"
                      :label="$t('User.follow_label11')"
                    >
                      <!-- <el-form-item v-if="followForm.track_followmode=='2'" prop="class_id" label="试听班级："> -->
                      <el-input
                        type="text"
                        :disabled="followForm.audition_genre == ''"
                        style="width: 340px"
                        @focus="leaning()"
                        @click="leaning()"
                        :placeholder="$t('User.follow_placeholder11_1')"
                        v-model="className"
                      ></el-input>
                      <br />
                      <el-input
                        type="text"
                        :disabled="followForm.audition_genre == ''"
                        style="width: 340px; margin-top: 15px"
                        :placeholder="$t('User.follow_placeholder11_2')"
                        v-model="followForm.class_cnname"
                      ></el-input>
                      <el-input
                        type="hidden"
                        style="width: 0px"
                        @focus="leaning()"
                        @click="leaning()"
                        :placeholder="$t('User.follow_placeholder11_1')"
                        v-model="followForm.class_id"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followmode == '3'"
                      :label="$t('User.follow_label12')"
                    >
                      <el-date-picker
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :placeholder="$t('User.follow_placeholder12')"
                        v-model="followForm.audition_visittime"
                        style="width: 340px"
                      ></el-date-picker>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followmode == '-1'"
                      :label="$t('User.follow_label13')"
                    >
                      <el-select
                        filterable
                        v-model="followForm.invite_genre"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder13')"
                      >
                        <el-option
                          :label="$t('User.follow_options5[0]')"
                          value="0"
                        ></el-option>
                        <el-option
                          :label="$t('User.follow_options5[1]')"
                          value="1"
                        ></el-option>
                        <el-option
                          :label="$t('User.follow_options5[2]')"
                          value="2"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="沟通模板：">
                      <!-- TraceNoteData -->
                      <el-select
                        filterable
                        v-model="checkList"
                        style="width: 340px"
                        placeholder="请选择常用模板"
                        @change="handClickModel()"
                      >
                        <el-option
                          v-for="items in TraceNoteData"
                          :key="items.tracenote_code"
                          :label="items.tracenote_remk"
                          :value="items.tracenote_remk"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="沟通内容：" prop="track_note">
                      <el-input
                        type="textarea"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder14_2')"
                        v-model="followForm.track_note"
                      ></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('User.follow_label15')">
                      <el-select
                        filterable
                        v-model="followForm.track_followuptype"
                        style="width: 340px"
                        :placeholder="$t('User.follow_placeholder15')"
                      >
                        <el-option
                          :label="$t('User.follow_options6[0]')"
                          value="0"
                        ></el-option>
                        <el-option
                          :label="$t('User.follow_options6[1]')"
                          value="1"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      v-if="followForm.track_followuptype == '1'"
                      :label="$t('User.follow_label16')"
                    >
                      <el-date-picker
                        type="date"
                        :placeholder="$t('User.follow_placeholder16')"
                        value-format="yyyy-MM-dd"
                        v-model="followForm.track_followuptime"
                        :picker-options="pickerOptions"
                        style="width: 340px"
                      ></el-date-picker>
                    </el-form-item>
                  </el-form>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="main_right"></div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 添加标签的弹框 -->
    <addTapPop
      v-if="addTagVisable"
      :dialogVisable="addTagVisable"
      :defautLabelList="UserInformation.client_tags"
      @handleCloseTip="addTagVisable = false"
      @handCancel="addTagVisable = false"
      @handConfirm="confirmTag"
    ></addTapPop>
  </div>
</template>

<script>
import http from "../../views/Customersmanage/channelRecord.js";
import addTapPop from "./addTapPop";
import dragDialog from "./dragDialog";
import Vue from "vue";

export default {
  name: "dialPhone",
  props: {
    showPhoneDialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showDialog: this.showPhoneDialog,
      //左侧列表数据
      keyword: "",
      dialList: [],
      dialActiveName: "first",
      dialIndex: 0,
      dialObj: {},
      waitDialLength: 0,
      alreadyDialLength: 0,

      // 头部
      UserInformation: {},
      addTagVisable: false,
      isMove: false,
      e: {},
      // 跟进部分数据
      followActiveName: "first",
      followForm: {
        client_id: "",
        track_linktype: "",
        track_validinc: "",
        track_intention_level: null,
        track_followuptype: "",
        track_followuptime: "",
        track_followmode: "", //本次跟进模式0普通回访1柜询2试听3转正-1跟进无意向
        // track_note_temp: "", //沟通模板不需要传
        track_note: "",
        class_id: "",
        class_cnname: "",
        invite_genre: "", //邀约柜询类型 邀约类型 变量 0普通柜询1能力测试
        client_lapsedtype: "", //无意向类型 0已报异业1强烈抵触2其他
        object_code: "", //沟通对象
        audition_genre: "", //试听类型
        receiver_name: "", //接待人
      },
      CommodeData: [], //获取沟通类型
      ObjectData: [], //获取沟通对象
      ReceiverList: [], //接待人->获取有接待权限的接待人
      BindingInfor: [],
      TraceNoteData: [], //沟通模板
      checkList: ["1", "柜询"],

      // 跟进校验规则
      followRules: {
        receiver_name: [
          {
            required: true,
            message: this.$t("User.follow_rule1"),
            trigger: "blur",
          },
        ],
        class_id: [
          {
            required: true,
            message: this.$t("User.follow_rule2"),
            trigger: "change,blur",
          },
        ],
        invite_visittime: [
          {
            required: true,
            message: this.$t("User.follow_rule3"),
            trigger: "change",
          },
        ],
        audition_visittime: [
          {
            required: true,
            message: this.$t("User.follow_rule4"),
            trigger: "change",
          },
        ],
        track_note: [
          {
            required: true,
            message: this.$t("User.follow_rule5"),
            trigger: "blur",
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now();
        },
      },
    };
  },
  methods: {
    //左侧列表操作
    getDialRecord() {
      http
        .getDialRecord({
          keyword: this.keyword,
          dialrecord_type: this.dialActiveName == "first" ? 0 : 1,
        })
        .then((res) => {
          const { code, msg, data: body } = res.data;
          const data = body;
          this.waitDialLength =
            this.dialActiveName == "first" ? data.allnum : data.allnums;
          this.alreadyDialLength =
            this.dialActiveName == "first" ? data.allnums : data.allnum;
          if (code === 200) {
            this.dialList = data.list;
            this.dialObj = this.dialList[this.dialIndex];
            this.getclientOne();
          } else {
            this.dialList = [];
            this.dialObj = {};
          }
        });
    },
    chooseDial(v, i) {
      this.dialIndex = i;
      this.dialObj = v;
      this.getclientOne();
    },
    // 头部
    getclientOne() {
      http
        .getclientOne({
          client_id: this.dialObj.client_id,
        })
        .then((res) => {
          this.UserInformation = res.data.data.list;
          //   this.num = parseInt(this.UserInformation.client_intention_level);
          //   if (res.data.data.is_track == "1") {
          //     this.isyhavetrack = true;
          //     this.isyhavetrackedit = true;
          //     // this.activeName = "fourth";
          //     if (this.activeName == "first") {
          //       this.isRoottrack = false;
          //       this.isyhavetrackedit = false;
          //     }
          //   } else {
          //     this.isyhavetrack = false;
          //     this.isyhavetrackedit = false;
          //   }

          (() => {})(this.UserInformation);
        });
    },
    callPhone(v) {
      const math = Math.random();
      if (!this.$refs.dragDialog) {
        const container = this.$refs.container;
        const div = document.createElement("div");
        container.append(div);
        const close = () => {
          const dialog = this.$refs["dragDialog" + math].$refs.dragDialog;
          app.$destroy(div);
          dialog.remove();
        };
        const replay = () => {
          close();
          this.callPhone(v);
        };
        const status = parseInt((Math.random() * 100) % 4) + 1;
        const app = new Vue({
          render: (h) => {
            const create = this.$createElement;
            return create(dragDialog, {
              ref: "dragDialog" + math,
              props: {
                obj: v,
                status,
                width: container.offsetWidth / 2 - 300,
                height: container.offsetHeight / 2 - 150,
                e: this.e,
              },
              on: {
                close,
                replay,
              },
            });
          },
        });
        app.$mount(div);
      }
      (() => {})(this.$refs.dragDialog);
    },
    onMousemove(e) {
      this.e = e;
    },
    confirmTag(val) {
      let labelList = [];
      val.forEach((item) => {
        labelList.push({
          label_id: item.label_id,
        });
      });
      this.$http
        .addClientTagsAction({
          client_id: this.dialObj.client_id,
          label_list: JSON.stringify(labelList),
        })
        .then((res) => {
          (() => {})(res.data);
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getclientOne();
            this.addTagVisable = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      //
    },

    // 跟进
    sourceFilter() {
      // 数据初始化
      this.followForm.track_followuptype = "";
      this.followForm.track_followuptime = "";
      this.followForm.track_note = "";
      this.followForm.class_id = "";
      this.followForm.receiver_name = "";
      this.followForm.class_cnname = "";
      this.checkList = "";
      this.className = "";
    },
    //关闭弹窗
    handClose() {
      this.$emit("handClose", false);
    },
  },
  computed: {},
  components: {
    addTapPop,
    dragDialog,
  },
  watch: {
    showPhoneDialog(val) {
      // Object.assign(this.$data, this.$options.data());
      this.showDialog = val;
      if (val) {
        this.getDialRecord();
      }
    },
  },
};
</script>

<style lang="less">
.dialPhone {
  @media (max-width: 1366px) {
    .input-cont {
      width: 150px !important;
    }
  }
  .el-radio-group {
    line-height: 30px !important;
    .el-radio {
      margin-left: 0 !important;
      margin-right: 30px !important;
    }
  }
  .el-dialog__wrapper {
    .el-dialog {
      .el-dialog__body {
        border-bottom: none;
        height: calc(100% - 55px);
        padding: 0;
        .dial_container {
          background-color: #f1f4fa;
          height: 100%;
          display: flex;

          .dial_left {
            margin-right: 10px;
            background-color: #ffffff;
            // width: 420px;
            width: 22%;
            height: 100%;
            .dial_list {
              display: flex;
              flex-direction: column;
              overflow-y: auto;
              height: calc(100% - 130px);

              .one_dial {
                cursor: pointer;
                padding: 10px 20px;
                height: 92px;
                display: flex;
                align-items: center;
                &.active_dial {
                  background-color: #e3f2fa;
                  border-right: 2px solid #23a8d8;
                }
                .student_info {
                  width: calc(100% - 92px);
                  height: 60px;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  .info_top {
                    font-size: 18px;
                    color: #333333;
                    display: flex;
                    align-items: center;
                    flex-wrap: nowrap;
                    span {
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                      flex-shrink: 1;
                    }
                    img {
                      width: 15px;
                      height: 15px;
                      margin-left: 5px;
                    }
                  }
                  .info_bottom {
                    font-size: 14px;
                    :nth-child(1) {
                      color: #55606e;
                    }
                    :nth-child(2) {
                      color: #333333;
                    }
                  }
                }
                > img {
                  width: 72px;
                  height: 72px;
                  margin-right: 10px;

                  flex-shrink: 0;
                }
              }
            }
          }
          .dial_right {
            height: 100%;
            flex-grow: 1;
            display: flex;
            flex-direction: column;

            .dial_header {
              width: 100%;
              height: 130px;
              margin-bottom: 10px;
              background-color: #ffffff;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .header_left {
                padding: 10px;
                .header_student {
                  display: flex;
                  align-items: center;
                  > img {
                    width: 72px;
                    height: 72px;
                    margin-right: 10px;
                  }
                  .student_info {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    height: 60px;

                    .info_top {
                      font-size: 18px;
                      color: #333333;
                      display: flex;
                      align-items: center;
                      flex-wrap: nowrap;
                      span {
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                        flex-shrink: 1;
                      }
                      img {
                        width: 15px;
                        height: 15px;
                        margin-left: 5px;
                      }
                    }
                    .info_bottom {
                      font-size: 14px;
                      .info_label {
                        color: #55606e;
                      }
                      .info_content {
                        color: #333333;
                        margin-right: 40px;
                      }
                    }
                  }
                }
                .header_label {
                  height: 28px;
                  margin: 10px 10px 0 82px;
                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  width: 348px;
                  .tagItem {
                    text-align: center;
                    display: block;
                    min-width: 80px;
                    height: 28px;
                    line-height: 28px;
                    border-radius: 15px;
                    color: #28abd9;
                    font-size: 14px;
                    padding: 0 18px;
                    border: 1px solid #28abd9;
                    margin-right: 20px;
                  }
                  .addTagBtn {
                    color: #28abd9;
                    cursor: pointer;
                  }
                }
              }
              .header_right {
                display: flex;
                align-items: center;
                flex-direction: column;
                font-size: 14px;
                margin-right: 36px;
                cursor: pointer;
                img {
                  margin-bottom: 10px;
                  width: 46px;
                  height: 46px;
                }
              }
            }
            .dial_main {
              display: flex;
              flex-grow: 1;
              height: calc(100% - 10px);
              overflow-y: auto;
              .main_left {
                background-color: #ffffff;
                width: calc(50% - 5px);
                margin-right: 10px;
                overflow-y: auto;
              }
              .main_right {
                background-color: #ffffff;
                width: calc(50% - 5px);
                height: 100%;
                overflow-y: auto;
              }
            }
          }
        }
      }
    }
    .is-fullscreen {
      top: 5%;
      width: 90% !important;
      height: 90% !important;
    }
  }
}
</style>
